import React from 'react'
import { fnum } from '../../utils/utils'
import EditPaymentForm from './EditPaymentForm'
import moment from 'moment'

export default class PaymentItem extends React.Component {

  state = {edit: false}

  onclick = e => {
    e.preventDefault();
    this.setState({edit: true});
  }

  cancelEdit = () => {
    this.setState({edit: false});
  }

  render() {
    const { edit } = this.state;
    const { post, editPost, srvcs } = this.props;
    if (edit){
      return (
        <EditPaymentForm
          data={post}
          srvcs={srvcs}
          editPost={editPost}
          cancelEdit={this.cancelEdit}
          updtBlnc={this.props.updtBlnc}
          blnc={this.props.blnc}
        />
      );
    }
    else{
      const style = post.post_payed ? (post.post_price < 0 ? 'info' : 'success')
        : (post.post_bdate>moment().format('Y-MM-DD') ? '' : 'danger' );
      return (
        <tr className={style} onClick={this.onclick}>
          <td>{post.post_desc}</td>
          <td className="text-right">{fnum(post.post_price)}</td>
          <td>{moment(post.post_bdate).format("L")} {" "} {post.post_payed ? "оплачен" : ""}</td>
          <td>{post.post_note}</td>
        </tr>
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/payment/PaymentItem.js